import gql from 'graphql-tag'

export const GET_PROJECTS = gql`
  query GetProjects($limit: Int = 4, $page: Int) {
    projects(order: desc, limit: $limit, page: $page) {
      id
      defaultStyle
      updatedAt
      name
    }
  }
`

export const GET_PROJECT = gql`
  query GetProject($projectId: ID!) {
    project(projectId: $projectId) {
      id
      name
      defaultStyle
      public
    }
  }
`

export const FETCH_PROJECT = gql`
  query FetchProject($projectId: ID!) {
    project(projectId: $projectId) {
      id
      name
      defaultStyle
      date: updatedAt
      createdAt
    }
  }
`

export const GET_PROJECT_COUNT = gql`
  query GetProjectCount {
    projectCount {
      count
    }
  }
`

export const FETCH_PROJECTS = gql`
  query FetchProjects(
    $order: Order = desc
    $orderBy: OrderBy = updatedAt
    $limit: Int = 20
    $filter: String = null
  ) {
    projects(
      order: $order
      orderBy: $orderBy
      limit: $limit
      filter: $filter
      showStar: true
    ) {
      id
      defaultStyle
      date: updatedAt
      createdAt
      name
      starred: star
      public
    }
  }
`

export const GET_PROJECTS_BY_FOLDER = gql`
  query GetProjectsByFolder(
    $folderId: Int!
    $order: Order = null
    $orderBy: OrderBy = null
    $limit: Int = 20
    $filter: String = null
  ) {
    projects(
      limit: $limit
      filter: $filter
      folderId: $folderId
      showStar: true
      order: $order
      orderBy: $orderBy
    ) {
      id
      name
      defaultStyle
      date: updatedAt
      starred: star
      public
    }
  }
`

export const SEARCH_PROJECTS = gql`
  query SearchProjects(
    $order: Order = desc
    $orderBy: OrderBy = updatedAt
    $limit: Int = 20
    $filter: String = null
    $name: String = ""
  ) {
    projects(
      order: $order
      orderBy: $orderBy
      limit: $limit
      filter: $filter
      search: { name: $name }
      showStar: true
    ) {
      id
      name
      defaultStyle
      date: updatedAt
      starred: star
      public
    }
  }
`

export const SEARCH_PROJECTS_BY_NAME = gql`
  query SearchProjectsByName(
    $order: Order = desc
    $limit: Int = 20
    $page: Int = 1
    $name: String = ""
  ) {
    projects(order: $order, limit: $limit, page: $page, search: { name: $name }) {
      name
      id
      defaultStyle
      updatedAt
    }
  }
`

export const MOVE_PROJECTS_TO_FOLDER = gql`
  mutation MoveProjects($folderId: Int!, $projectIds: [String!]!) {
    moveProjects(folderId: $folderId, projectIds: $projectIds) {
      folderId
      projectId
      createdAt
    }
  }
`

export const CREATE_PROJECT = gql`
  mutation CreateProject($name: String!, $public: Boolean!, $defaultStyle: String!) {
    createProject(name: $name, public: $public, defaultStyle: $defaultStyle) {
      id
      name
      public
      defaultStyle
      public
    }
  }
`

export const FOLDERS_CREATE_PROJECT = gql`
  mutation FoldersCreateProject(
    $name: String!
    $public: Boolean!
    $defaultStyle: String!
    $folderId: Int = null
  ) {
    createProject(
      name: $name
      public: $public
      defaultStyle: $defaultStyle
      folderId: $folderId
    ) {
      id
      name
      defaultStyle
      date: updatedAt
      public
    }
  }
`

export const UPDATE_PROJECT = gql`
  mutation UpdateProject(
    $projectId: String!
    $name: String!
    $public: Boolean!
    $defaultStyle: String!
  ) {
    updateProject(
      projectId: $projectId
      name: $name
      public: $public
      defaultStyle: $defaultStyle
    ) {
      id
      name
      public
      defaultStyle
    }
  }
`

export const VISIT_PROJECT = gql`
  mutation VisitProject($projectId: String!) {
    visitProject(projectId: $projectId) {
      id
      name
      defaultStyle
      date: updatedAt
      public
    }
  }
`

export const DELETE_PROJECTS = gql`
  mutation DeleteProjects($ids: [String!]!) {
    deleteProjects(projectIds: $ids) {
      deletedProjectsCount
    }
  }
`

export const STAR_PROJECT = gql`
  mutation StarProject($id: String!, $star: Boolean!) {
    starProject(projectId: $id, star: $star) {
      star
    }
  }
`
